import React, { useEffect, useState } from 'react';

export function Footer() {
    const currentYear = new Date().getFullYear();

    const [dadJoke, setDadJoke] = useState('');

    useEffect(() => {
        const fetchData = async () => {
            try {
                const headers = { 'X-API-KEY': '7EAFDEADBEEF' };
                const response = await fetch('/api/v1/dadJokes/', { headers });

                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }

                const data = await response.text();
                setDadJoke(data);
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };

        fetchData();
    }, []);

    return (
        <div className="card-footer">
            <a href="https://www.margosupplies.com/">Margo Supplies {currentYear}</a>&nbsp;&nbsp;
            <a href="mailto:info@margosupplies.com">Need Help?</a>
            <p>{dadJoke}</p>
        </div>
    )
}